import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./login.scss";
import "../../css/login.css";

import logo from "../../Assets/seoimg/logo.png";
import closeEyeIcon from "../../Assets/common/close-eye.svg";
import openEyeIcon from "../../Assets/common/open-eye.svg";

import { login_withAPi } from "../../../services/constants";
import { ReCaptcha } from "../../share/components/googleRecaptacha";
import SocialJuice from "../../share/components/SocialJuice";
import Spin from "@semcore/spin";
import { useTranslation } from "react-i18next";

import Loginslider from "./loginSlider";
import AddProjectStore from "../../../store/AddProjectStore";

const Login = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  // useState variables
  const [Email, setEmail] = useState("");
  const [mydata, setMydata] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [PassSecure, setPassSecure] = useState(false);

  const domain = window.location.hostname; // 💡 Not in `location`
  const { appliedWhiteLable } = AddProjectStore((state) => state);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
      dispatch({ type: "USER", payload: true });
    }
  }, [token, dispatch, navigate]);

  const getlang = async () => {
    const response = await axios.get(
      `https://app.rankspro.io/api/user/getlang/?email=${Email}`
    );
    if (response.data?.language) {
      i18n.changeLanguage(response.data.language);
      localStorage.setItem("APP_LANG", response.data?.language);
    } else {
      localStorage.setItem("APP_LANG", "en");
    }
  };

  const login = async (e) => {
    e.preventDefault();
    if (Email === "" || password === "") {
      setMydata(t("auth.login.required_validation"));
    } else {
      setIsLoading(true);
      localStorage.clear();
      let item = {
        email: Email,
        password: password,
      };
      axios
        .post(login_withAPi(), item)
        .then((res) => {
          const status = res?.data?.status;
          if (status === "200") {
            localStorage.setItem("token", res.data.token.access);
            dispatch({ type: "LOADING" });
            dispatch({ type: "USER", payload: true });
            getlang();
          } else {
            setMydata(res.data.msg);
          }
        })
        .catch((error) => {
          setMydata(error.response?.data?.email[0]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <div className="loginBox acc-container">
        <div className="left-side">
          <div className="left-side-container">
            <img
              className="brand-logo"
              key={appliedWhiteLable.header_logo || logo}
              src={appliedWhiteLable.header_logo || logo}
              alt="login img"
            />
            <Loginslider />
          </div>
        </div>
        <div className="right-side">
          <div className="login-container">
            <img
              className="brand-logo"
              key={appliedWhiteLable.header_logo || logo}
              src={appliedWhiteLable.header_logo || logo}
              alt="login img"
            />
            <div className="social-juice">
              {domain === "app.rankspro.io" || domain === "localhost" ? (
                <SocialJuice id="e9499166-1c27-4903-ab39-9210750013c7" />
              ) : null}
            </div>
            <div className="login-desc text-center">
              <h1 className="headline">{t("auth.login.title")}</h1>
              <p className="tagline">
                Welcome back! Let’s pick up where you left off.
              </p>
            </div>
            <form onChange={() => setMydata("")} className="login-form">
              <input
                type="text"
                placeholder={t("auth.login.form.email")}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="true"
              />
              <div className="password-type my-4">
                <input
                  type={PassSecure ? "text" : "password"}
                  placeholder={t("auth.login.form.password")}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                {PassSecure ? (
                  <img
                    src={closeEyeIcon}
                    alt=""
                    onClick={() => setPassSecure(false)}
                  />
                ) : (
                  <img
                    src={openEyeIcon}
                    alt=""
                    onClick={() => setPassSecure(true)}
                  />
                )}
              </div>
              <p className="forgot">
                {" "}
                <span className="vl-msd-line-login">{mydata}</span>
                <span className="">
                  <Link
                    to="/forgot"
                    style={{ color: "#6254FF", fontWeight: "500" }}
                  >
                    {t("auth.login.forgot_password")}
                  </Link>
                </span>{" "}
              </p>
              <div>
                <button
                  type="submit"
                  className="login_btn w-100"
                  onClick={login}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="d-flex w-100 align-items-center justify-content-center">
                      <Spin size="s" />
                    </div>
                  ) : (
                    t("auth.login_now")
                  )}
                </button>
                <h6 className="rs-now">
                  {t("auth.do_not_have_an_account")}{" "}
                  <Link
                    to="/register"
                    style={{ color: "#6254FF", fontWeight: "500" }}
                  >
                    {" "}
                    {t("auth.register_now")}
                  </Link>
                </h6>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ReCaptcha />
    </>
  );
};

export default Login;
